import commonZh from './zh/common_zh' //公用
import loginZh from './zh/login_zh' //登录
import dataScreenZh from './zh/dataScreen_zh' //大屏
import multiStationZh from './zh/multiStation_zh' //多站总览

import deviceMonitorZh from './zh/deviceMonitor_zh' //设备监控
import elecPriceZh from './zh/elecPrice_zh' //电价管理
import poStaManageZh from './zh/powerStaManage_zh' //电站管理
import repPowerZh from './zh/repPower_zh' //电量报表
import faultWarningZh from './zh/faultWarning_zh' //站点告警

import repProfitZh from './zh/repProfit_zh' //收益报表
import stationCardZh from './zh/sationCard_zh' //站点卡片
import stationOverviewZh from './zh/stationOverview_zh' //单站概览
import stationSystemZh from './zh/stationSystem_zh' //站点系统

import alarmMonitorZh from './zh/alarmMonitor_zh' //告警监控

import stenManageZh from './zh/stencilManage_zh' //公共模版
import sysManageZh from './zh/sysManage_zh' //系统管理
import userManageZh from './zh/userManage_zh' //用户管理
import workOrderZh from './zh/workOrder_zh' //工单管理
export default {
  ...commonZh,
  ...loginZh,
  ...dataScreenZh,
  ...multiStationZh,
  ...deviceMonitorZh,
  ...elecPriceZh,
  ...faultWarningZh,
  ...poStaManageZh,
  ...repPowerZh,
  ...repProfitZh,
  ...stationCardZh,
  ...stationOverviewZh,
  ...stationSystemZh,
  ...alarmMonitorZh,
  ...stenManageZh,
  ...sysManageZh,
  ...userManageZh,
  ...workOrderZh,
  工商业储能云平台: '工商业储能云平台',
  智慧储能云平台: '智慧储能云平台',
  STE智慧储能云: 'STE智慧储能云',
  '赛唯E宝 工商业储能云平台': '赛唯E宝 工商业储能云平台',
  '驰硕-智慧储能云平台': '驰硕-智慧储能云平台',
  '云基慧-智慧储能云平台': '云基慧-智慧储能云平台',
  鹏洲储能云平台: '鹏洲储能云平台',
  智慧储能管控平台: '智慧储能管控平台',
  客户名称: '客户名称',
  数据大屏: '数据大屏',
  多站总览: '多站总览',
  单站数据: '单站数据',
  电站概览: '电站概览',
  站点系统: '站点系统',
  设备监控: '设备监控',
  故障告警: '故障告警',
  电价管理: '电价管理',
  统计报表: '统计报表',
  电量报表: '电量报表',
  收益报表: '收益报表',
  系统管理: '系统管理',
  电站管理: '电站管理',
  公共模版: '公共模版',
  账号管理: '账号管理',
  系统管理: '系统管理',
  运维管理: '运维管理',
  工单管理: '工单管理',
  收起: '收起',

  退出登录: '退出登录',
  修改密码: '修改密码',
  原密码: '原密码',
  确认新密码: '确认新密码',
  请输入原密码: '请输入原密码',
  请输入新密码: '请输入新密码',
  '密码更改成功，请重新登录': '密码更改成功，请重新登录!',

  查询: '查询',
  重置: '重置',
  导出: '导出',
  序号: '序号',
  创建电站: '创建电站',

  站点总数: '站点总数',
  在线: '在线',
  离线: '离线',
  个: '个',
  装机功率: '装机功率',
  装机容量: '装机容量',

  今日充电量: '今日充电量',
  月充电: '月充电',
  累计充电: '累计充电',

  今日放电量: '今日放电量',
  月放电: '月放电',
  累计放电: '累计放电',

  今日收益: '今日收益',
  本月收益: '本月收益',
  总收益: '总收益',
  '当日/元': '当日/元',
  '当月/万元': '当月/万元',

  今日告警: '今日告警',
  已结束: '已结束',
  发生中: '发生中',
  条: '条',

  较昨日增长: '较昨日增长',
  较昨日下降: '较昨日下降',

  关闭: '关闭',

  收益统计: '收益统计',
  充放电统计: '充放电统计',
  收益排名: '收益排名',
  近7日: '近7日',
  近31日: '近31日',
  近12月: '近12月',
  三十日内: '30日内',
  一年内: '1年内',
  本周: '本周',
  本月: '本月',
  本年: '本年',
  收益万元: '收益/万元',
  单位: '单位',
  收益: '收益',
  充电: '充电',
  放电: '放电',

  站点列表: '站点列表',
  通讯状态: '通讯状态',
  全部: '全部',
  电站筛选: '电站筛选',
  待运维电站: '待运维电站',
  电站状态: '电站状态',
  电站名称: '电站名称',
  今日告警: '今日告警',
  在线状态: '在线状态',
  // 今日充电量: '今日充电量',
  // 今日放电量: '今日放电量',
  总充电量: '总充电量',
  总放电量: '总放电量',
  '昨日收益(元)': '昨日收益(元)',
  '总收益(万元)': '总收益(万元)',
  综合效率: '综合效率',
  '指单位时间内的电站放电量 ÷ 充电量': '指单位时间内的电站放电量 ÷ 充电量。',

  放电达成率: '放电达成率',
  放电天数: '放电天数',

  '指单位时间内的电站放电量 ÷（装机容量 × 放电天数），放电天数指实际放电大于 0 的天数': '指单位时间内的电站放电量 ÷（装机容量 × 放电天数），放电天数指实际放电大于 0 的天数。',
  电网有功功率: '电网有功功率',
  储能有功功率: '储能有功功率',
  负载有功功率: '负载有功功率',

  站点信息: '站点信息',
  电站类型: '电站类型',
  装机总容量: '装机总容量',
  投运时间: '投运时间',
  电站地址: '电站地址',
  查看详细: '查看详细',
  效率: '效率',
  暂无站点图片: '暂无站点图片',
  查看电站: '查看电站',
  // 工商业: '工商业',
  // 户用: '户用',

  远程控制: '远程控制',
  能量管理: '能量管理',
  禁止放电: '禁止放电',
  能量控制: '能量控制',
  防过载: '防过载',
  防逆流: '防逆流',
  防逆流时段: '防逆流时段',
  余量功率: '余量功率',
  防过载功能: '防过载功能',
  防逆流功能: '防逆流功能',
  '请确认是否启用防过载功能？': '请确认是否启用防过载功能？',
  '请确认是否禁用防过载功能？': '请确认是否禁用防过载功能？',
  '请确认是否启用防逆流功能？': '请确认是否启用防逆流功能？',
  '请确认是否禁用防逆流功能？': '请确认是否禁用防逆流功能？',

  能量控制策略应用月份需满足12个月点击页面底部应用按钮下发后方可执行: '能量控制策略应用月份需满足 12 个月，点击页面底部“应用”按钮下发后，方可执行。',
  新建策略: '新建策略',
  应用月份: '应用月份',
  操作人: '操作人',
  请确认是否删除该策略: '请确认是否删除该策略？',
  引用: '引用',
  应用月份未满12个月请新建策略: '应用月份未满12个月，请新建策略！',
  已满12个月可点击应用按钮下发执行: '已满12个月，可点击“应用”按钮下发执行！',
  最大充电功率: '最大充电功率',
  最大放电功率: '最大放电功率',
  编辑策略: '编辑策略',
  应用月份选择: '应用月份选择',
  月份支持一次选择多个选择完成后在下方填写所选月份的能量控制参数: '月份支持一次选择多个，选择完成后在下方填写所选月份的能量控制参数。',
  月份: '月份',
  能量控制参数: '能量控制参数',
  为选择的月份设置参数后需点击确定按钮: '为选择的月份设置参数后，需点击“确定”按钮。',
  对应时段: '对应时段',
  请选择配置月份: '请选择配置月份！',
  请配置能量控制参数: '请配置能量控制参数！',
  请选择时间: '请选择时间！',
  请输入最大放电功率: '请输入最大放电功率！',
  请输入最大充电功率: '请输入最大充电功率！',
  '最大充电功率数值范围0-9999整数': '最大充电功率数值范围0-9999整数',
  '最大放电功率数值范围0-9999整数': '最大放电功率数值范围0-9999整数',

  已满12个月无法引用: '已满12个月，无法引用。',
  已满12个月无法新建策略: '已满12个月，无法新建策略。',
  该月份在其他策略中已选择: '该月份在其他策略中已选择。',
  查看详情: '查看详情',
  '1月': '1月',
  '2月': '2月',
  '3月': '3月',
  '4月': '4月',
  '5月': '5月',
  '6月': '6月',
  '7月': '7月',
  '8月': '8月',
  '9月': '9月',
  '10月': '10月',
  '11月': '11月',
  '12月': '12月',
  一月: '1月',
  二月: '2月',
  三月: '3月',
  四月: '4月',
  五月: '5月',
  六月: '6月',
  七月: '7月',
  八月: '8月',
  九月: '9月',
  十月: '10月',
  十一月: '11月',
  十二月: '12月',
  月1: '月',
  刷新: '刷新',

  数值范围: '数值范围',
  余量功率设置时请将参数控制在变压器容量的百分之五至百分之二十之间: '余量功率设置时，请将参数控制在变压器容量的5%～20%之间。',
  请确认是否应用余量功率参数: '请确认是否应用余量功率参数！',
  请确认是否应用能量控制参数: '请确认是否应用能量控制参数！',
  请确认是否应用防过载参数: '请确认是否应用防过载参数！',
  请确认是否应用防逆流参数: '请确认是否应用防逆流参数！',

  能量控制策略应用月份需满足12个月点击页面底部应用按钮下发后方可执行: '能量控制策略应用月份需满足 12 个月，点击页面底部“应用”按钮下发后，方可执行。',

  设置参数后需点击应用按钮方可执行无充电或放电操作的时间段将执行待机操作: '设置参数后，需点击“应用”按钮方可执行。无充电或放电操作的时间段，将执行待机操作！',
  设置参数时请按照禁充阈值大于限充阈值大于启动阈值填写: '设置参数时，请按照 “禁充阈值 > 限充阈值 > 启动阈值” 填写！ ',
  请按照禁充阈值大于限充阈值大于启动阈值填写: '请按照 “禁充阈值 > 限充阈值 > 启动阈值” 填写！',
  设置参数时请按照启动阈值大于限放阈值大于禁放阈值填写: '设置参数时，请按照 “启动阈值 > 限放阈值 > 禁放阈值” 填写！ ',
  请按照启动阈值大于限放阈值大于禁放阈值填写: '请按照 “启动阈值 > 限放阈值 > 禁放阈值” 填写！ ',
  执行储能控制类别: '执行储能控制类别',
  计划功率: '计划功率',
  请输入功率: '请输入功率',
  跟随能量控制自动配置: '跟随能量控制自动配置',
  应用: '应用',
  防过载设置: '防过载设置',
  防过载控制: '防过载控制',
  限充阈值: '限充阈值',
  限放阈值: '限放阈值',
  请输入: '请输入',
  启动阈值: '启动阈值',
  禁充阈值: '禁充阈值',
  禁放阈值: '禁放阈值',
  调节量: '调节量',
  防逆流设置: '防逆流设置',
  防逆流控制: '防逆流控制',
  请输入计划功率: '请输入计划功率',
  '计划功率数值范围0-9999整数': '计划功率数值范围0-9999整数',
  请选择类别: '请选择类别',
  请输入限充阈值: '请输入限充阈值',
  请输入启动阈值: '请输入启动阈值',
  请输入禁充阈值: '请输入禁充阈值',
  请输入调节量: '请输入调节量',
  请输入限放阈值: '请输入限放阈值',
  请输入禁放阈值: '请输入禁放阈值',

  余量功率设置: '余量功率设置',
  变压器容量: '变压器容量',
  充电余量: '充电余量',
  放电余量: '放电余量',
  EMS使能: 'EMS使能',
  使能: '使能',
  禁能: '禁能',
  请输入变压器容量: '请输入变压器容量',
  请输入充电余量: '请输入充电余量',
  请输入放电余量: '请输入放电余量',

  是否放弃修改: '是否放弃修改？',
  当前页面参数已调整请确认是否要放弃修改: '当前页面参数已调整，请确认是否要放弃修改？',
  时段设置冲突: '时段设置冲突',
  时间段设置不可重叠请重新调整: '时间段设置不可重叠，请重新调整！',
  好的: '好的',
  放弃: '放弃',

  手动控制: '手动控制',
  并网控制: '并网控制',
  PCS控制: 'PCS控制',
  控制设置: '控制设置',
  当前状态: '当前状态',
  控制类别: '控制类别',
  控制参数: '控制参数',
  跟随能量控制: '跟随能量控制',
  调整控制模式: '调整控制模式',
  '下发“并网/离网”指令后，请“开启/断开”市电网电路！': '下发“并网/离网”指令后，请“开启/断开”市电网电路！',
  并网运行: '并网运行',
  离网运行: '离网运行',
  '请确认是否下发PCS运行/停机指令！': '请确认是否下发PCS运行/停机指令！',
  PCS运行: 'PCS运行',
  PCS停机: 'PCS停机',
  请确认是否应用: '请确认是否应用？',

  二级保护: '二级保护',
  二级保护设置: '二级保护设置',
  当前参数: '当前参数',
  SOC上限: 'SOC上限',
  SOC下限: 'SOC下限',
  SOC充电上限: 'SOC充电上限',
  SOC放电下限: 'SOC放电下限',
  放电截止电压: '放电截止电压',
  充电截止电压: '充电截止电压',
  过放释放电压: '过放释放电压',
  过充释放电压: '过充释放电压',
  二级保护参数设置: '二级保护参数设置',
  请输入SOC上限: '请输入SOC上限',
  请输入SOC下限: '请输入SOC下限',
  请输入充电SOC上限: '请输入SOC充电上限',
  请输入SOC放电下限: '请输入SOC放电下限',
  请输入放电截止电压: '请输入放电截止电压',
  请输入充电截止电压: '请输入充电截止电压',
  请输入过放释放电压: '请输入过放释放电压',
  请输入过充释放电压: '请输入过充释放电压',
  '请确认是否应用二级保护参数？': '请确认是否应用二级保护参数？',

  当前站点系统: '当前站点系统',
  已离线: '已离线',
  最后数据时间: '最后数据时间',
  系统列表: '系统列表',
  请输入内容: '请输入内容',
  系统编号: '系统编号',
  总有功功率: '总有功功率',
  负载功率: '负载功率',
  今日充放电量: '今日充/放电量',
  总充放电量: '总充/放电量',
  累计充放电量: '累计充/放电量',
  负载用电量: '负载用电量',
  实时数据: '实时数据',
  电池堆: '电池堆',
  告警状态: '告警状态',
  进入设备监控: '进入设备监控',
  名称: '名称',
  状态: '状态',
  运行状态: '运行状态',
  光伏: '光伏',
  电网: '电网',
  负载: '负载',
  储能: '储能',
  功率趋势: '功率趋势',
  最大充电功率: '最大充电功率',
  最大放电功率: '最大放电功率',
  最大负载功率: '最大负载功率',
  功率: '功率',
  实时运行: '实时运行',
  数据类型: '数据类型',
  运行曲线: '运行曲线',
  '请选择设备和字段！': '请选择设备和字段！',
  实时: '实时',
  实时电量收益: '实时电量收益',
  请选择站点系统时间: '请选择站点,系统，时间！',
  日期: '日期',
  时间: '时间',
  充电量: '充电量',
  放电量: '放电量',
  当前收益元: '当前收益(元)',
  尖: '尖',
  峰: '峰',
  平: '平',
  谷: '谷',
  总: '总',
  禁放阀值小于限放阀值小于启动阀值: '禁放阀值 < 限放阀值 < 启动阀值',
  启动阀值小于限放阀值小于禁放阀值: '启动阀值 < 限放阀值 < 禁放阀值',

  数据时间: '数据时间',
  数据导出: '数据导出',
  电表: '电表',
  空调: '空调',
  箱变: '箱变',
  工作状态: '工作状态',
  运行: '运行',
  故障: '故障',
  停机: '停机',
  并网状态: '并网状态',
  并网: '并网',
  离网: '离网',
  设备状态: '设备状态',
  正常: '正常',
  控制模式: '控制模式',
  手动: '手动',
  远程: '远程',
  当日充电量: '当日充电量',
  当日放电量: '当日放电量',
  交流频率: '交流频率',
  总交流有功功率: '总交流有功功率',
  总交流无功功率: '总交流无功功率',
  总交流视在功率: '总交流视在功率',
  总交流功率因数: '总交流功率因数',
  A相有功功率: 'A相有功功率',
  B相有功功率: 'B相有功功率',
  C相有功功率: 'C相有功功率',
  A相无功功率: 'A相无功功率',
  B相无功功率: 'B相无功功率',
  C相无功功率: 'C相无功功率',
  A相视在功率: 'A相视在功率',
  B相视在功率: 'B相视在功率',
  C相视在功率: 'C相视在功率',
  AB电压: 'AB电压',
  BC电压: 'BC电压',
  CA电压: 'CA电压',
  AB电流: 'AB电流',
  BC电流: 'BC电流',
  CA电流: 'CA电流',
  A相电压: 'A相电压',
  B相电压: 'B相电压',
  C相电压: 'C相电压',
  A相电流: 'A相电流',
  B相电流: 'B相电流',
  C相电流: 'C相电流',
  PCS模块温度: 'PCS模块温度',
  PCS环境温度: 'PCS环境温度',
  PCS散热器温度: 'PCS散热器温度',
  A1模块温度: 'A1模块温度',
  B1模块温度: 'B1模块温度',
  C1模块温度: 'C1模块温度',
  A2模块温度: 'A2模块温度',
  B2模块温度: 'B2模块温度',
  C2模块温度: 'C2模块温度',
  进风口温度: '进风口温度',
  出风口温度: '出风口温度',
  故障状态字: '故障状态字',
  支路一: '支路一',
  支路: '支路',
  直流功率: '直流功率',
  直流电压: '直流电压',
  直流电流: '直流电流',
  类别: '类别',
  日正向总电能: '日正向总电能',
  日反向总电能: '日反向总电能',
  累计正向总电能: '累计正向总电能',
  累计反向总电能: '累计反向总电能',

  堆状态: '堆状态',
  簇状态: '簇状态',
  禁充: '禁充',
  禁放: '禁放',

  与PCS通信: '与PCS通信',
  与EMS通信: '与EMS通信',
  电池堆视图: '电池堆视图',
  电池簇视图: '电池簇视图',
  单体电池视图: '单体电池视图',

  充放电状态: '充放电状态',
  空闲: '空闲',
  总电压: '总电压',
  总电流: '总电流',
  充电限制功率: '充电限制功率',
  放电限制功率: '放电限制功率',
  可充电量: '可充电量',
  可放电量: '可放电量',
  平均温度: '平均温度',
  平均电压: '平均电压',
  绝缘值: '绝缘值',
  正极绝缘值: '正极绝缘值',
  负极绝缘值: '负极绝缘值',
  最高温度: '最高温度',
  最低温度: '最低温度',
  最高电压: '最高电压',
  最低电压: '最低电压',
  电池组: '电池组',

  电压: '电压',
  电流: '电流',
  接触器主正: '接触器主正',
  接触器预充: '接触器预充',
  接触器总负: '接触器总负',
  接触器总正: '接触器总正',
  断开: '断开',
  闭合: '闭合',

  // 单位: '单位',
  最高: '最高',
  最低: '最低',
  均衡: '均衡',
  电池单体电压: '电池单体电压',
  单体电压: '单体电压',
  电池单体温度: '电池单体温度',
  单体温度: '单体温度',

  待机: '待机',
  系统状态: '系统状态',
  关机: '关机',
  开机: '开机',
  湿度: '湿度',
  交流电压: '交流电压',
  出风温度: '出风温度',
  回风温度: '回风温度',
  冷凝温度: '冷凝温度',
  盘管温度: '盘管温度',
  柜外温度: '柜外温度',
  柜内温度: '柜内温度',
  柜内湿度: '柜内湿度',
  排气温度: '排气温度',
  出风湿度: '出风湿度',
  融霜湿度: '融霜湿度',
  融霜温度: '融霜温度',
  制热开启温度: '制热开启温度',
  制冷开启温度: '制冷开启温度',
  制热禁止温度: '制热禁止温度',
  制冷禁止温度: '制冷禁止温度',
  高温告警温度: '高温告警温度',
  低温告警温度: '低温告警温度',
  高湿告警点: '高湿告警点',
  // 高温告警点: '高温告警点',
  // 低温告警点: '低温告警点',
  // 报警时间: '报警时间',
  // 高低温告警: '高低温告警',
  // 高低压告警: '高低压告警',
  // 压缩机告警: '压缩机告警',
  // 传感器告警: '传感器告警',
  // 高低气压告警: '高低气压告警',
  排氢状态: '排氢状态',
  电加热: '电加热',
  压缩机: '压缩机',
  应急风机: '应急风机',
  室内风机: '室内风机',
  室外风机: '室外风机',
  停止: '停止',
  空调控制: '空调控制',
  请输入制冷启动温度: '请输入制冷启动温度！',
  请输入制冷关闭温度: '请输入制冷关闭温度！',
  请输入制热启动温度: '请输入制热启动温度！',
  请输入制热关闭温度: '请输入制热关闭温度！',
  请输入高温告警温度: '请输入高温告警温度！',
  请输入低温告警温度: '请输入低温告警温度！',
  '制冷启动温度 - 制冷关闭温度 ≥ 1': '制冷启动温度 - 制冷关闭温度 ≥ 1',
  '制热关闭温度- 制热启动温度 ≥ 1': '制热关闭温度- 制热启动温度 ≥ 1',
  请确认是否应用空调控制参数: '请确认是否应用空调控制参数！',
  请确认是否应用空调温度参数: '请确认是否应用空调温度参数！',
  温度参数设置: '温度参数设置',
  '点击“确定”按钮前，请确认参数是否正确！': '点击“确定”按钮前，请确认参数是否正确！',
  一键空调启停: '一键空调启停',
  '部分空调控制能力互斥，无法同时开启！': '部分空调控制能力互斥，无法同时开启！',
  '点击“确定”按钮前，请确认参数是否正确！': '点击“确定”按钮前，请确认参数是否正确！',
  加热启停: '加热启停',
  制冷启停: '制冷启停',
  待机启停: '待机启停',
  送风启停: '送风启停',
  开1: '开启',
  关1: '关闭',
  开: '开',
  关: '关',
  是否确认开启空调: '是否确认开启空调？',
  是否确认关闭空调: '是否确认关闭空调?',
  空调参数配置: '空调参数配置',
  '制冷启动温度数字范围 -100 - 100': '制冷启动温度数字范围 -100 - 100',
  '制冷关闭温度数字范围 -100 - 100': '制冷关闭温度数字范围 -100 - 100',
  '制热启动温度数字范围 -100 - 100': '制热启动温度数字范围 -100 - 100',
  '制热关闭温度数字范围 -100 - 100': '制热关闭温度数字范围 -100 - 100',
  '高温告警温度数字范围 -100 - 100': '高温告警温度数字范围 -100 - 100',
  '低温告警温度数字范围 -100 - 100': '低温告警温度数字范围 -100 - 100',
  制冷启动温度: '制冷启动温度',
  制冷关闭温度: '制冷关闭温度',
  制热启动温度: '制热启动温度',
  制热关闭温度: '制热关闭温度',
  除湿开启温度: '除湿开启温度',
  除湿关闭温度: '除湿关闭温度',
  除湿开启湿度: '除湿开启湿度',
  除湿关闭湿度: '除湿关闭湿度',
  内风机转速: '内风机转速',
  外风机转速: '外风机转速',

  风扇: '风扇',
  转速: '转速',
  风扇启停: '风扇启停',
  风扇参数配置: '风扇参数配置',
  风扇启动温度: '风扇启动温度',
  风扇关闭温度: '风扇关闭温度',

  tms液冷: 'TMS',
  TMS机组运行状态: 'TMS 机组运行状态',
  TMS运行模式: 'TMS 运行模式',
  自动: '自动',
  准备启动: '准备启动',
  tms运行: '运行',
  tms延时停机: '延时停机',
  tms故障: '故障',
  制冷: '制冷',
  加热: '加热',
  自循环: '自循环',
  TMS供液温度: 'TMS 供液温度',
  TMS回液温度: 'TMS 回液温度',
  TMS恒温方式预设温度: 'TMS 恒温方式预设温度',
  TMS供液压力: 'TMS 供液压力',
  TMS回液压力: 'TMS 回液压力',
  环境温度: '环境温度',
  电芯温度: '电芯温度',
  电芯电压: '电芯电压',
  高压箱温度: '高压箱温度',

  通信状态: '通信状态',
  无通信: '无通信',
  异常: '异常',
  CO浓度: 'CO浓度',
  氢气浓度: '氢气浓度',
  烟雾数值: '烟雾数值',
  VOC数值: 'VOC数值',
  温度数值: '温度数值',
  CO浓度报警: 'CO浓度报警',
  高温报警: '高温报警',
  温度报警: '温度报警',
  VOC报警: 'VOC报警',
  烟雾报警: '烟雾报警',
  氢气浓度报警: '氢气浓度报警',
  水浸报警: '水浸报警',
  是否确认开启消防: '是否确认开启消防？',
  是否确认关闭消防: '是否确认关闭消防？',
  报警等级: '报警等级',
  预留: '预留',
  '1级报警': '1级报警',
  '2级报警': '2级报警',
  '3级报警': '3级报警',
  '4级报警': '4级报警',
  无故障: '无故障',
  无通信: '无通信',
  异常: '异常',
  消防: '消防',

  消防开关控制: '消防开关控制',
  故障码: '故障码',
  暂无: '暂无',

  外设: '外设',
  急停状态: '急停状态',
  急停故障: '急停故障',
  消防状态: '消防状态',
  消防触发: '消防触发',
  温感状态: '温感状态',
  温度异常: '温度异常',
  门禁状态: '门禁状态',
  开启: '开启',
  水浸状态: '水浸状态',
  水浸故障: '水浸故障',
  烟感状态: '烟感状态',
  烟雾报警: '烟雾报警',

  高压分合闸状态: '高压分合闸状态',
  合闸: '合闸',
  分闸: '分闸',
  远方就地状态: '远方就地状态',
  就地: '就地',
  远方: '远方',
  高压: '高压',
  高压IA: '高压IA',
  高压IB: '高压IB',
  高压IC: '高压IC',
  高压3IO: '高压3IO',
  低压: '低压',
  低压UAN: '低压UAN',
  低压UBN: '低压UBN',
  低压UCN: '低压UCN',
  低压UAB: '低压UAB',
  低压IA: '低压IA',
  低压IB: '低压IB',
  低压UBC: '低压UBC',
  低压UCA: '低压UCA',
  低压IC: '低压IC',
  低压3IO: '低压3IO',
  低压频率: '低压频率',
  低压有功功率: '低压有功功率',
  低压无功功率: '低压无功功率',
  温度: '温度',
  油温: '油温',
  低压功率因数: '低压功率因数',
  告警图表: '告警图表',
  告警列表: '告警列表',
  设备类型: '设备类型',
  告警等级: '告警等级',
  监控: '监控',
  光伏逆变器: '光伏逆变器',
  // 传感器: '传感器',
  // IO控制器: 'IO控制器',
  电池簇: '电池簇',
  未分级: '未分级',
  预警: '预警',
  告警: '告警',
  起止时间: '起止时间',
  开始时间: '开始时间',
  结束时间: '结束时间',
  设备名称: '设备名称',
  告警标题: '告警标题',
  客户告警: '客户告警',
  故障发生时间: '故障发生时间',
  告警开始时间: '告警开始时间',
  告警结束时间: '告警结束时间',
  未修复: '未修复',
  报警升级: '报警升级',
  报警降级: '报警降级',
  故障修复: '故障修复',
  请选择站点: '请选择站点！',
  处理建议: '处理建议',
  无需处理: '无需处理',
  运维处理: '运维处理',
  告警配置: '告警配置',
  请勾选可查看的处理建议类型: '请勾选可查看的处理建议类型',

  电价配置: '电价配置',
  模板管理: '模板管理',

  为对应月份选择模板后请点击绑定按钮以完成应用更换模板前请先点击解绑按钮才可重新选择: '为对应月份选择模板后，请点击“绑定”按钮以完成应用。更换模板前请先点击”解绑”按钮，才可重新选择。',
  年份: '年份',
  选择年份: '选择年份',
  请选择: '请选择',
  绑定: '绑定',
  当前: '当前',
  解绑: '解绑',
  查看: '查看',
  模板详情: '模板详情',
  模板名称: '模板名称',
  模板状态: '模板状态',
  使用中: '使用中',
  未使用: '未使用',
  使用情况: '使用情况',
  模板标签: '模板标签',
  开始时间: '开始时间',
  结束时间: '结束时间',
  时段: '时段',
  买入电价元kWh: '买入电价(元/kWh)',
  卖出电价元kWh: '卖出电价(元/kWh)',
  是否确认解绑该模板: '是否确认解绑该模板？',
  提示: '提示',
  确定电价: '确定',
  点击引用模板按钮可将公共模板中的电价模板直接引用至当前页面下: '点击“引用模板”按钮，可将“公共模板”中的电价模板直接引用至当前页面下！',
  请输入内容例如模版名称标签: '请输入内容，例如模版名称、标签',
  引用模板: '引用模板',
  创建模板: '创建模板',
  标签: '标签',
  创建人: '创建人',
  创建时间: '创建时间',
  操作: '操作',
  引用创建: '引用创建',
  编辑: '编辑',
  删除: '删除',
  该模版正在使用中暂不支持删除请解绑后再操作: '该模版正在使用中，暂不支持删除，请解绑后再操作！',
  是否确认删除该模板: '是否确认删除该模板？',
  模版编辑: '模版编辑',
  基础信息: '基础信息',
  时段与电价: '时段与电价',
  请输入模版名称: '请输入模版名称',
  模版名称: '模版名称',
  标签名称: '标签名称',
  请输入标签名称: '请输入标签名称',
  生成: '生成',
  标签名称以空格分隔完成后回车或点击生成按钮即可生成标签每个标签最多可输入20个字符最多支持生成10个标签:
    '标签名称以空格分隔，完成后回车或点击“生成”按钮即可生成标签。每个标签最多可输入20个字符，最多支持生成10个标签。',
  标签管理: '标签管理',
  取消: '取消',
  确定: '确定',
  点击编辑后可以勾选标签后进行删除操作: '点击“编辑”后，可以勾选标签后，进行删除操作',
  确定修改: '确定修改',
  下一步: '下一步',
  最多还可添加: '最多还可添加',
  个标签: '个标签',
  单个标签字符长度不可超过20: '单个标签字符长度不可超过20',
  请选择要删除的标签: '请选择要删除的标签',
  模板中时段与电价被修改后数据将同步到已绑定的月份中请谨慎操作: '模板中时段与电价被修改后，数据将同步到已绑定的月份中，请谨慎操作！',
  时间编辑: '时间编辑',
  选择时间: '选择时间',
  时段说明: '时段说明',
  新增: '新增',
  电价编辑: '电价编辑',
  确定添加: '确定添加',
  请选择开始时间: '请选择开始时间',
  开始时间不可与结束时间相同: '开始时间不可与结束时间相同',
  选择结束时间: '选择结束时间',
  请选择结束时间: '请选择结束时间',
  结束时间不可与开始时间相同: '结束时间不可与开始时间相同',
  请选择时间段类型: '请选择时间段类型',
  请输入买入价格: '请输入买入价格',
  请输入卖出价格: '请输入卖出价格',
  买入价格: '买入价格',
  卖出价格: '卖出价格',
  '买入价格数字范围 0 - 10000': '买入价格数字范围 0 - 10000',
  '卖出价格数字范围 0 - 10000': '卖出价格数字范围 0 - 10000',
  时间段存在冲突请重新配置: '时间段存在冲突,请重新配置',
  选择需要引用的模板后点击确认按钮可将对应模板引用至模板管理中: '选择需要引用的模板后，点击“确认”按钮，可将对应模板引用至模板管理中。',
  确定引用: '确定引用',
  请选择引用模板: '请选择引用模板',
  展开全部: '展开全部',

  站点汇总展示所有站点报表数据支持按日展示31天按月展示一年内数据: '站点汇总展示所有站点报表数据，支持按日展示31天，按月展示一年内数据。',
  站点汇总: '站点汇总',
  单站报表: '单站报表',
  时间范围: '时间范围',
  开始日期: '开始日期',
  结束日期: '结束日期',
  开始月份: '开始月份',
  结束月份: '结束月份',
  开始年份: '开始年份',
  结束年份: '结束年份',
  报表导出: '报表导出',
  充电量kWh: '充电量(kWh)',
  放电量kWh: '放电量(kWh)',
  按日: '按日',
  按月: '按月',
  按年: '按年',
  请选择时间范围: '请选择时间范围！',
  站点名称: '站点名称',
  报表类型: '报表类型',
  日报表: '日报表',
  月报表: '月报表',
  年报表: '年报表',

  选择站点: '选择站点',
  充电价格元: '充电价格(元)',
  放电价格元: '放电价格(元)',
  充电价格: '充电价格',
  放电价格: '放电价格',
  元: '元',
  实际收益元: '实际收益(元)',
  总计: '总计',

  系统数量: '系统数量',
  // 装机功率MW: '装机容量(MWh)',
  // 装机容量MWh: '装机容量MWh',
  修改: '修改',
  是否确认删除电站操作: '是否确认删除电站操作',
  电站联系电话: '电站联系电话',
  电站图片: '电站图片',
  修改电站: '修改电站',
  创建电站后需绑定系统: '创建电站后需绑定系统',
  电站创建完成后需前往系统管理选择对应系统分配到电站后才可正常运行: '电站创建完成后，需前往系统管理，选择对应系统分配到电站后，才可正常运行',
  更多信息: '更多信息',
  请输入装机功率: '请输入装机功率',
  请输入装机容量: '请输入装机容量',
  装机功率数值范围大于0小于10000: '装机功率数值范围大于0小于10000',
  装机容量数值范围大于0小于10000: '装机容量数值范围大于0小于10000',
  '站点变压器容量数值范围1-9999整数': '站点变压器容量数值范围1-9999整数',
  请输入电站联系电话: '请输入电站联系电话',
  选择日期: '选择日期',
  国家: '国家',
  省: '省',
  市: '市',
  区: '区',
  详细地址: '详细地址',
  电站经纬度: '电站经纬度',
  获取经纬度: '获取经纬度',
  经度: '经度',
  纬度: '纬度',
  重新获取: '重新获取',
  点击上传: '点击上传',
  重新上传: '重新上传',
  创建: '创建',
  经纬度: '经纬度',
  请输入地区: '请输入地区',
  请输入电站名称: '请输入电站名称',
  请选择电站类型: '请选择电站类型',
  未匹配到地点: '未匹配到地点!',
  未找到搜索结果: '未找到搜索结果!',
  格式有误图片大小不得超过5M支持PNGJPG格式: '格式有误，图片大小不得超过5M，支持PNG、JPG格式。',
  上传的图片大小不得超过5M支持PNGJPG格式: '上传的图片大小不得超过5M,支持PNG、JPG格式。',

  电站业主: '电站业主',
  请输入电站业主称呼: '请输入电站业主称呼',
  电站联系号码: '电站联系号码',
  请输入电站联系号码: '请输入电站联系号码',
  站点变压器容量: '站点变压器容量',
  请输入变压器容量: '请输入站点变压器容量',
  并网点信息: '并网点信息',
  变压器信息: '变压器信息',
  请输入变压器信息: '请输入变压器信息',
  额度变压器容量: '额度变压器容量',
  请输入额度变压器容量: '请输入额度变压器容量',
  安装人: '安装人',
  请输入安装人称呼: '请输入安装人称呼',
  安装人联系号码: '安装人联系号码',
  请输入安装人联系号码: '请输入安装人联系号码',
  安装图片: '安装图片',
  点击上传图片: '点击上传图片',
  上传的图片大小不得超过5M支持PNGJPG格式最多可上传5张图片: '上传的图片大小不得超过5M，支持PNG、JPG格式，最多可上传 5 张图片。',
  最多5张图片当前总数已超过请重新选择: '最多5张图片,当前总数已超过,请重新选择！',
  图片大小不可超过5M: '图片大小不可超过5M',
  示例说明: '示例说明',
  '请按照示例上传图片以达到更佳展示效果。（建议使用横图，主体部分位于中央区域）': '请按照示例上传图片以达到更佳展示效果。（建议使用横图，主体部分位于中央区域）',
  有光伏: '有光伏',
  无光伏: '无光伏',
  有并网点: '有并网点',
  无并网点: '无并网点',

  电价模版: '电价模版',

  新增账号: '新增账号',
  请输入内容例如姓名手机邮箱: '请输入内容，例如姓名、手机、邮箱',
  邮箱: '邮箱',
  手机: '手机',
  禁用: '禁用',
  角色: '角色',
  创建日期: '创建日期',
  请确认是否禁用此账号: '请确认是否禁用此账号？',
  请确认是否恢复此账号: '请确认是否恢复此账号？',
  恢复: '恢复',
  更多: '更多',
  查看账号: '查看账号',
  重置密码: '重置密码',
  密码重置: '密码重置',
  请确认是否删除此账号: '请确认是否删除此账号？',
  站点分配: '站点分配',
  邮箱与手机至少填写一项用作为登录账号: '邮箱与手机至少填写一项用作为登录账号',
  登录邮箱: '登录邮箱',
  密码: '密码',
  请勾选需要分配站点名称: '请勾选需要分配站点名称',
  全部站点: '全部站点',
  所有站点包括未来新增站点: '所有站点（包括未来新增站点）',
  平台管理员默认管理所有站点包含未来新增站点不再支持站点自由分配: '平台管理员默认管理所有站点（包含未来新增站点），不再支持站点自由分配！',
  账号权限: '账号权限',
  分配站点: '分配站点',
  新密码: '新密码',
  确认密码: '确认密码',
  六至二十位字符: '6-20位字符',
  请输入确认密码: '请输入确认密码',
  两次密码不一致请重新输入: '两次密码不一致，请重新输入',
  请输入密码: '请输入密码',
  请输入名称: '请输入名称',
  请选择角色: '请选择角色',
  请输入手机号码: '请输入手机号码',
  请输入邮箱地址: '请输入邮箱地址',
  编辑账号: '编辑账号',
  手机号邮箱不可同时为空: '手机号邮箱不可同时为空',

  系统总览: '系统总览',
  批量添加: '批量添加',
  添加系统: '添加系统',
  当需要添加的系统较多时可点击批量添加按钮批量添加请先: '当需要添加的系统较多时，可点击批量添加按钮。（批量添加请先',
  下载Excel模板: '下载Excel模板',
  填写完成后再进行上传提交: ' ，填写完成后再进行上传提交）',
  请选择归属: '请选择归属',
  请输入内容例如EMS编号归属系统编号: '请输入内容，例如EMS编号、归属、系统编号、ICCID',
  EMS编号: 'EMS编号',

  归属状态: '归属状态',
  暂无归属: '暂无归属',
  未归属: '未归属',
  电站: '电站',
  客户: '客户',
  归属: '归属',
  额定功率kW: '额定功率(kW)',
  标称电压V: '标称电压(V)',
  冷却方式: '冷却方式',
  尺寸mm: '尺寸(mm)',
  重量kg: '重量(kg)',
  是否确认删除系统操作: '是否确认删除系统操作？',
  系统分配: '系统分配',
  是否确认撤回此次分配操作: '是否确认撤回此次分配操作？',
  系统撤回: '系统撤回',
  请输入EMS编号: '请输入EMS编号',
  请输入系统编号: '请输入系统编号',
  系统名称: '系统名称',
  自定义系统编号名称: '自定义系统编号名称',
  规格参数: '规格参数',
  请输入额定功率: '请输入额定功率',
  请输入额定容量: '请输入额定容量',
  请输入标称电压: '请输入标称电压',
  请选择冷却方式: '请选择冷却方式',
  请输入尺寸长宽高: '请输入尺寸(长*宽*高)',
  请输入重量: '请输入重量',
  查看系统: '查看系统',
  额定功率: '额定功率',
  额定容量: '额定容量',
  标称电压: '标称电压',
  尺寸: '尺寸',
  重量: '重量',

  额定功率数值范围大于0小于1000000: '额定功率数值范围大于0小于1000000',
  额定容量数值范围大于0小于1000000: '额定容量数值范围大于0小于1000000',
  标称电压数值范围大于0小于1000000: '标称电压数值范围大于0小于1000000',
  重量数值范围大于0小于1000000: '重量数值范围大于0小于1000000',

  选择电站名称: '选择电站名称',
  厂家: '厂家',
  输入厂家编码: '输入厂家编码',
  文件上传完成后点击提交按钮以完成导入: '文件上传完成后，点击提交按钮以完成导入',
  文件大小: '文件大小',
  上传日期: '上传日期',
  拖拽到此区域: '拖拽到此区域',
  请上传Excel文件文件大小在1M内: '请上传Excel文件，文件大小在1M内',
  文件大小不符合规则请上传Excel文件文件大小在1M内: '文件大小不符合规则，请上传Excel文件，文件大小在1M内',
  风冷: '风冷',
  液冷: '液冷',
  其它: '其它',
  无: '无',
  修改系统: '修改系统',
  请选择分配电站: '请选择分配电站',
  系统已成功分配给电站: '系统已成功分配给电站',
  请输入客户编码: '请输入客户编码',
  EMS系统批量导入模板: 'EMS系统-批量导入模板.xlsx',
  请上传格式内容正确文件: '请上传格式内容正确文件！',
  系统列表Excel已成功导入: '系统列表Excel已成功导入！',
  系统列表Excel导入失败请检查后重新尝试: '系统列表Excel导入失败，请检查后重新尝试！',
  请使用模板文件的格式进行上传上传文件只能是xlsxlsx格式: '请使用模板文件的格式进行上传，上传文件只能是 xls、xlsx格式！',
  请使用模板文件的格式进行上传上传文件大小不可超过1M: '请使用模板文件的格式进行上传，上传文件大小不可超过1M！',
  系统信息为空请重新上传: '系统信息为空，请重新上传！',
  EMS平台系统批量导入表格: 'EMS平台系统-批量导入表格',
  EMS编号和系统编号不可为空: 'EMS编号和系统编号不可为空！',
  已成功导入: '已成功导入',
  条数据: '条数据',
  失败1: '失败 ',
  条1: '条',
  请下载文件查看失败原因: '请下载文件查看失败原因！',

  登录: '登录',
  账号: '账号',
  密码: '密码',
  请输入登录邮箱与密码: '请输入登录邮箱与密码',
  请输入账号: '请输入账号',
  记住密码: '记住密码',
  忘记密码: '忘记密码',
  我已阅读并同意: '我已阅读并同意',
  隐私协议: '隐私协议',
  登录中: '登 录 中',
  登录: '登 录',
  还没有账号: '还没有账号？',
  立即注册: '立即注册',
  请确认已阅读并同意隐私协议: '请确认已阅读并同意"隐私协议"',
  账号注册完成正在审核中后续将有工作人员与您联系: '账号注册完成，正在审核中，后续将有工作人员与您联系！',
  账号正在审核中后续将有工作人员与您联系: '账号正在审核中，后续将有工作人员与您联系！',
  账号审核未通过请完善注册信息: '账号审核未通过，请完善注册信息！',
  前往填写: '前往填写',
  该账号目前没有权限访问: '该账号目前没有权限访问！',
  该账号已退出登录或没有资源权限即将返回登录页: '该账号已退出登录或没有资源权限即将返回登录页！',

  请输入注册邮箱账号和验证码来设置新密码: '请输入注册邮箱账号和验证码，来设置新密码',
  请再次输入密码: '请再次输入密码',
  验证码: '验证码',
  请输入验证码: '请输入验证码',
  已发送: '已发送',
  发送中: '发送中',
  获取验证码: '获取验证码',
  提交: '提交',
  返回登录: '返回登录',
  发送成功: '发送成功',
  发送失败: '发送失败',

  注册: '注册',
  注册信息补充: '注册信息补充',
  请按照流程依次填写等待账号审核: '请按照流程依次填写，等待账号审核',
  企业名称: '企业名称',
  请输入企业名称: '请输入企业名称',
  注册身份: '注册身份',
  请输入在企业中的职位: '请输入在企业中的职位',
  称呼: '称呼',
  请输入您的称呼: '请输入您的称呼',
  手机号: '手机号',
  请输入手机号: '请输入手机号',
  完成: '完成',

  工商业储能数据云平台: '工商业储能数据云平台',
  大屏总充电量: '总充电量',
  大屏总放电量: '总放电量',
  大屏总充电: '总充电',
  大屏总放电: '总放电',
  年2: '年',
  年1: '年',
  电量指标: '电量指标',
  电站指标: '电站指标',
  收益排行: '收益排行',
  充放电趋势: '充放电趋势',
  告警统计: '告警统计',
  电站总数个: '电站总数（个）',
  电站总数: '电站总数',
  总装机功率: '总装机功率',
  总装机容量: '总装机容量',
  收益指标: '收益指标',
  累计收益万元: '累计收益/万元',
  '累计收益/元': '累计收益/元',
  累计收益: '累计收益',
  今日收益元: '今日收益/元',
  收益趋势: '收益趋势',
  星期日: '星期日',
  星期一: '星期一',
  星期二: '星期二',
  星期三: '星期三',
  星期四: '星期四',
  星期五: '星期五',
  星期六: '星期六',
  weekday: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
  单位次: '单位/次',
  万元: '万元',
  单位万元: '单位/万元',

  电量趋势: '电量趋势',
  电站安全: '电站安全',
  安全运行时间天: '安全运行时间(天)',
  安全运行时间: '安全运行时间',
  天: '天',
  按日: '按日',
  按周: '按周',
  按月: '按月',
  排名: '排名',
  社会公益: '社会公益',
  CO2减排吨: 'CO2减排(吨)',
  节约标准煤吨: '节约标准煤(吨)',
  等效植树量棵: '等效植树量(棵)',
  周: '周',
  月: '月',
  返回: '返回',

  EMS设备ID: 'EMS设备ID',
  测试交流频率: '交流频率',
  功率kW: '功率/kW',
  有功功率: '有功功率',
  电池单体: '电池单体',
  并离网状态: '并离网状态',
  PCS通信状态: 'PCS通信状态',
  EMS通信状态: 'EMS通信状态',
  电池堆总电压: '电池堆总电压',
  可充电量: '可充电量',
  可放电量: '可放电量',
  平均电压: '平均电压',
  电池堆总电流: '电池堆总电流',
  累计充电量: '累计充电量',
  累计放电量: '累计放电量',
  平均温度: '平均温度',
  电池簇数量: '电池簇数量',
  循环次数: '循环次数',
  单体最高温度: '单体最高温度',
  单体最高温度簇ID: '单体最高温度簇ID',
  单体最高温度ID: '单体最高温度ID',
  单体最高温度组ID: '单体最高温度组ID',
  单体最低温度: '单体最低温度',
  单体最低温度簇ID: '单体最低温度簇ID',
  单体最低温度ID: '单体最低温度ID',
  单体最低温度组ID: '单体最低温度组ID',
  单体最高电压: '单体最高电压',
  单体最高电压簇ID: '单体最高电压簇ID',
  单体最高电压ID: '单体最高电压ID',
  单体最高电压组ID: '单体最高电压组ID',
  单体最低电压: '单体最低电压',
  单体最低电压簇ID: '单体最低电压簇ID',
  单体最低电压ID: '单体最低电压ID',
  单体最低电压组ID: '单体最低电压组ID',
  绝缘电阻: '绝缘电阻',
  正极绝缘电阻: '正极绝缘电阻',
  负极绝缘电阻: '负极绝缘电阻',
  簇: '簇',
  簇电压: '簇电压',
  簇电流: '簇电流',
  A相功率: 'A相功率',
  B相功率: 'B相功率',
  C相功率: 'C相功率',
  主正接触器: '主正接触器',
  主负接触器: '主负接触器',
  电池簇电压: '电池簇电压',
  电池簇电流: '电池簇电流',
  电芯数量: '电芯数量',
  温感数量: '温感数量',
  电压差: '电压差',
  单体最小值: '单体最小值',
  单体最小ID: '单体最小ID',
  单体最大值: '单体最大值',
  单体最大ID: '单体最大ID',
  单体编号: '单体编号',
  月正向总电能: '月正向总电能',
  月反向总电能: '月反向总电能',
  PCS工作状态: 'PCS工作状态',
  实时有功功率: '实时有功功率',
  实时无功功率: '实时无功功率',
  今日数据图表: '今日数据图表',
  总交流充电量: '总交流充电量',
  总交流放电量: '总交流放电量',
  当天交流充电量: '当天交流充电量',
  当天交流放电量: '当天交流放电量',
  交流总功率: '交流总功率',
  手动功率: '手动功率',
  AB交流线电压: 'AB交流线电压',
  BC交流线电压: 'BC交流线电压',
  CA交流线电压: 'CA交流线电压',
  AB交流线电流: 'AB交流线电流',
  BC交流线电流: 'BC交流线电流',
  CA交流线电流: 'CA交流线电流',
  三相电流绝对值和: '三相电流绝对值和',
  三相电流和: '三相电流和',
  漏电流: '漏电流',
  报警状态: '报警状态',
  报警时间: '报警时间',
  故障状态: '故障状态',
  是: '是',
  否: '否',

  暂无数据: '暂无数据',
  小于: '小于',
  小数点后: '小数点后不允许超过',
  不允许超过: '位',
  小数点后不允许超过位1位: '小数点后不允许超过1位',
  小数点后不允许超过位3位: '小数点后不允许超过3位',
  小数点后不允许超过位9位: '小数点后不允许超过9位',
  值大于0: '值大于0',
  请输入合法数字: '请输入合法数字！',
  // 请输入大于小于且小数点后不超过位的合法数字: '请输入大于小于且小数点后不超过位的合法数字',
  手机号码格式不正确: '手机号码格式不正确！',
  邮箱格式不正确: '邮箱格式不正确！',
  请输入大于0数字: '请输入大于0数字！',
  密码由620位字母或数字或字母数字特殊符号组成: '密码由6-20位字母或数字或字母、数字、特殊符号组成',
  密码必须由6至20个字符组成支持字母不区分大小写数字和特殊符号: '密码必须由6-20个字符组成，支持字母（不区分大小写）、数字和特殊符号。',
  登录已过期可以取消继续留在该页面或者重新登录: '登录已过期，可以取消继续留在该页面，或者重新登录',
  '登录已过期，请重新登录': '登录已过期，请重新登录！',
  重新登录: '重新登录',
  该账号目前没有资源权限即将返回登录页: '该账号目前没有资源权限,即将返回登录页...',
  不超过200个字符: '不超过200个字符',

  待分配: '待分配',
  新建工单: '新建工单',
  待接单: '待接单',
  处理中: '处理中',
  已处理: '已处理',
  已完成: '已完成',
  已关闭: '已关闭',
  工单编号: '工单编号',
  工单类型: '工单类型',
  紧急程度: '紧急程度',
  工单标题: '工单标题',
  安装工单: '安装工单',
  维修工单: '维修工单',
  紧急: '紧急',
  一般: '一般',
  分配工单: '分配工单',
  处理人: '处理人',
  关闭工单: '关闭工单',
  关闭原因: '关闭原因',
  填写关闭原因: '填写关闭原因',
  接单: '接单',
  处理: '处理',
  分配时间: '分配时间',
  接单时间: '接单时间',
  处理结束时间: '处理结束时间',
  分配工单成功: '分配工单成功',
  关闭工单成功: '关闭工单成功',
  编辑工单: '编辑工单',
  接单成功: '接单成功',
  您已成功接单: '您已成功接单',
  工单内容可在处理中进行查看处理: '工单内容可在处理中进行查看处理',
  选择系统: '选择系统',
  处理方式: '处理方式',
  工单详情: '工单详情',
  客户联系人: '客户联系人',
  客户联系电话: '客户联系电话',
  客户地址: '客户地址',
  新建成功: '新建成功',
  编辑成功: '编辑成功',
  请选择工单类型: '请选择工单类型',
  请输入工单标题: '请输入工单标题',
  处理结束: '处理结束',
  处理跟进: '处理跟进',
  填写工单处理内容后点击确认即可结束处理此工单: '填写工单处理内容后，点击“确认”即可结束处理此工单。',
  填写内容后点击提交即可更新工单处理状态: '填写内容后，点击“提交”即可更新工单处理状态。',
  工单附件: '工单附件',
  上传的附件只支持pdfdocdocxxlsxlsxtxt格式: '上传的附件只支持 pdf, doc, docx, xls, xlsx, txt格式。',
  工单旅程: '工单旅程',
  处理描述: '处理描述',
  确认完成: '确认完成',
  完成时间: '完成时间',
  关闭时间: '关闭时间',
  分配: '分配',
  点击上传附件: '点击上传附件',
  确认工单: '确认工单',
  查看工单: '查看工单',
  请输入有效的手机号码: '请输入有效的手机号码',
  请输入处理描述: '请输入处理描述',
  处理结束成功: '处理结束成功',
  处理跟进成功: '处理跟进成功',
  最多5个附件当前总数已超过请重新选择: '最多5个附件，当前总数已超过，请重新选择',
  禁止删除之前添加的图片文件: '禁止删除之前添加的图片文件',
  请输入工单编号标题内容: '请输入工单编号、标题、内容',
  文件大小不可超过10M: '文件大小不可超过10M',
  请选择处理人: '请选择处理人',
  时段报表: '时段报表',
  时段数据: '时段数据',
  折线图: '折线图',
  柱状图: '柱状图',
  表格: '表格',
  当日数据: '当日数据',
  累计数据: '累计数据',
  原始数据: '原始数据',
  系统: '系统 - ',
  原始数据导出: '原始数据导出',
  电量kWh: '电量/kWh',
  当日数据导出: '当日数据导出',
  累计数据导出: '累计数据导出',

  UPS开关控制: 'UPS开关控制',
  放电测试: '放电测试',
  上机状态: '上机状态',
  上电状态: '上电状态',
  待机状态: '待机状态',
  旁路状态: '旁路状态',
  市电工作状态: '市电工作状态',
  电池供电状态: '电池供电状态',
  测试自检放电状态: '测试自检放电状态',
  CONVERTER: 'CONVERTER',
  经济状态: '经济状态',
  关机状态: '关机状态',
  保留: '保留',
  UPS类型: 'UPS类型',
  UPS状态: 'UPS状态',
  UPS运行状态: 'UPS运行状态',
  后备: '后备',
  UPS温度: 'UPS温度',
  电池维持时间: '电池维持时间',
  输入: '输入',
  R相电压: 'R相电压',
  R相电流: 'R相电流',
  总视在功率: '总视在功率',
  S相电压: 'S相电压',
  S相电流: 'S相电流',
  R相视在功率: 'R相视在功率',
  T相电压: 'T相电压',
  T相电流: 'T相电流',
  S相视在功率: 'S相视在功率',
  频率: '频率',
  T相视在功率: 'T相视在功率',
  输出: '输出',
  直流电电池: '直流电（电池）',
  电池总压: '电池总压',
  电池温度: '电池温度',
  容量: '容量',
  额定信息: '额定信息',
  额定总功率: '额定总功率',
  输入输出相数: '输入输出相数',
  单进单出: '单进单出',
  三进单出: '三进单出',
  三进三出: '三进三出',
  额定输入电压种类: '额定输入电压种类',
  额定电池电压: '额定电池电压',
  输出定额电压: '输出定额电压',
  输出定额电流: '输出定额电流',
  输出定额频率: '输出定额频率',
  额定电池节数: '额定电池节数',
  节: '节',
  是否确认开启UPS: '是否确认开启UPS？',
  是否确认关闭UPS: '是否确认关闭UPS？',
  是否开启放电测试: '是否开启放电测试？',
  分配至: '分配至',
  接单账号: '接单账号',
  工单标题必须少于50个字符: '工单标题必须少于50个字符',
  处理方式必须少于20个字符: '处理方式必须少于20个字符',
  客户名称必须少于20个字符: '客户名称必须少于20个字符',
  客户联系人必须少于20个字符: '客户联系人必须少于20个字符',
  处理描述必须少于100个字符: '处理描述必须少于100个字符',
  联系电话必须少于20个字符: '联系电话必须少于20个字符',
  客户地址必须少于50个字符: '客户地址必须少于50个字符',
  工单详情必须少于200个字符: '工单详情必须少于200个字符',
  是否确认接单: '是否确认接单',
  站点卡片: '站点卡片',
  全部省: '全部省',
  全部市: '全部市',
  全部区: '全部区',
  编辑电站: '编辑电站',
  上传图片: '上传图片',
  上传文件: '上传文件',
  我知道了: '我知道了',
  平台功能更新说明: '平台功能更新说明',
  接收工单: '接收工单',
  处理进度更新: '处理进度更新',
  工单已确认处理完成: '工单已确认处理完成',
  处理完成: '处理完成',
  全部国家: '全部国家',
  全部区域: '全部区域',
  除湿器: '除湿器',
  控温状态: '控温状态',
  控湿状态: '控湿状态',
  除霜状态: '除霜状态',
  高温告警: '高温告警',
  外部温度: '外部温度',
  内部温度: '内部温度',
  控温方式: '控温方式',
  降温: '降温',
  升温: '升温',
  外部温度传感器故障状态: '外部温度传感器故障状态',
  内部温度传感器故障状态: '内部温度传感器故障状态',
  湿度传感器故障状态: '湿度传感器故障状态',
  风机故障状态: '风机故障状态',
  温度启动值: '温度启动值',
  温度关闭值: '温度关闭值',
  除湿器启动值: '除湿器启动值',
  除湿器关闭值: '除湿器关闭值',
  除湿启动值: '除湿启动值',
  除湿关闭值: '除湿关闭值',
  运行中: '运行中',
  未运行: '未运行',
  控温手自动模式: '控温手自动模式',
  控湿手自动模式: '控湿手自动模式',

  请输入站点名称搜索: '请输入站点名称搜索',
  请选择字段: '请选择字段',

  数据分析: '数据分析',
  字段选择: '字段选择',
  末次数据时间: '末次数据时间',
  查询结果: '查询结果',
  打开: '打开',
  请输入电站名称1: '请输入电站名称',
  暂无搜索内容: '暂无搜索内容',
  ems通信状态: 'ems通信状态',
  日发电量: '日发电量',
  总发电量: '总发电量',
  无功功率: '无功功率',
  功率因数: '功率因数',
  正极电压: '正极电压',
  负极电压: '负极电压',
  R相电压: 'R相电压',
  S相电压: 'S相电压',
  T相电压: 'T相电压',
  S相电流: 'S相电流',
  T相电流: 'T相电流',
  RS线电压: 'RS线电压',
  ST线电压: 'ST线电压',
  TR线电压: 'TR线电压',
  RS线电流: 'RS线电流',
  ST线电流: 'ST线电流',
  TR线电流: 'TR线电流',
  R相温度: 'R相温度',
  S相温度: 'S相温度',
  T相温度: 'T相温度',
  散热器温度: '散热器温度',
  电网频率: '电网频率',
  消防反馈: '消防反馈',
  火灾报警: '火灾报警',
  消防故障: '消防故障',

  消防喷洒: '消防喷洒',
  喷洒: '喷洒',
  火灾状态: '火灾状态',
  火灾: '火灾',
  消防设备: '消防设备',
  急停: '急停',
  浸水: '浸水',
  故障1: '故障',

  请选择地区: '请选择地区',
  搜索电站名称地址: '搜索电站名称/地址',

  进入电站: '进入电站',
  电站名称1: '电站名称',
  数量: '数量',
  以下为: '以下为',
  的站点: '的站点',

  充电桩: '充电桩',
  操作日志: '操作日志',
  充电桩控制: '充电桩控制',
  操作内容: '操作内容',
  操作账号: '操作账号',
  请选择控制指令后点击确定以下发: '请选择控制指令后，点击“确定”以下发！',
  控制指令: '控制指令',
  操作结果: '操作结果',
  成功: '成功',
  失败: '失败',
  运行1: '运行',
  待机1: '待机',
  开机1: '开机',
  关机1: '关机',
  送风: '送风',
  空调强控: '空调强控',
  TMS强控: 'TMS强控',
  强控模式: '强控模式',
  控制模式: '控制模式',
  控制类别: '控制类别',
  自动模式: '自动模式',
  强控模式下部分控制能力互斥无法同时开启: '强控模式下，部分控制能力互斥，无法同时开启!',
  如需解除强控指令请选择自动模式并应用以恢复到自动运行状态: '如需解除强控指令，请选择“自动模式”并应用,以恢复到自动运行状态！',
  清除强控指令并执行设备自动模式: '清除强控指令，并执行设备自动模式',
  请选择控制模式: '请选择控制模式！',
  请选择控制类别: '请选择控制类别！',
  本地控制: '本地控制',
  调试方式: '调试方式',
  指EMS禁止本地控制: '指EMS禁止本地控制。',
  指EMS禁止远程控制: '指EMS禁止远程控制。',
  仅支持在本地屏进行控制模式变更: '仅支持在“本地屏”进行控制模式变更。',
  批量操作: '批量操作',
  批量分配: '批量分配',
  当前已选: '当前已选',
  项: '项',
  系统批量分配: '系统批量分配',
  时间范围只能选择17天: '时间范围只能修改1-7天',
  未选配: '未选配',

  市电状态: '市电状态',
  电池电压状态: '电池电压状态',
  不正常: '不正常',
  低: '低',
  电池电压低: '电池电压低',
  转换器: '转换器',
  环境监测: '环境监测',
  环境湿度: '环境湿度',

  设备数据: '设备数据',
  设备故障字: '设备故障字',
  支路数据: '支路数据',
  电量数据: '电量数据',

  故障复位: '故障复位',
  确认提示: '确认提示',
  请确认是否下发故障复位指令该指令每30秒内只可下发一次: '请确认是否下发故障复位指令，该指令每 30 秒内只可下发一次！',
  工作模式: '工作模式',
  除湿: '除湿',
  制热: '制热',

  并网: '并网',
  离网: '离网',
  自检: '自检',
  错误码: '错误码',
  BMS并网控制: 'BMS并网控制',
  一键并网控制: '一键并网控制',
  请确认是否下发当前控制指令: '请确认是否下发当前控制指令？',
  全部堆: '全部堆',
  控制对象: '控制对象',
  请选择控制对象和控制指令: '请选择控制对象和控制指令',
  请选择控制对象: '请选择控制对象',
  请选择控制指令: '请选择控制指令',
  组: '组',
  单体: '单体',
  单体电池: '单体电池',
  转换器: '转换器',
  货币单位: '货币单位',

  电价表: '电价表',
  解除同步: '解除同步',
  国家: '国家',
  地区: '地区',
  起始日期: '起始日期',
  列表: '列表',
  趋势: '趋势',
  电价: '电价',
  时段: '时段',
  同步电价: '同步电价',
  请选择地区时区和起始时间后点击同步电价按钮平台将自动把对应电价数据与站点电价表同步: '请选择地区、时区和起始时间后，点击同步电价按钮，平台将自动把对应电价数据与站点电价表同步。',
  请确认是否将以下电价数据与电站同步: '请确认是否将以下电价数据与电站同步？',
  起始日: '起始日',
  能量控制参数由平台根据智慧能量管理算法生成请确保系统额定容量与额定功率数值真实准确: '能量控制参数由平台根据智慧能量管理算法生成，请确保系统“额定容量”与“额定功率”数值真实准确。',
  智慧控制: '智慧控制',
  人工控制: '人工控制',
  手动能量控制: '手动能量控制',
  时区: '时区',
  额定容量: '额定容量',
  启用: '启用',
  智慧策略: '智慧策略',
  当前策略: '当前策略',
  历史策略: '历史策略',
  人工: '人工',
  通过智慧算法生成: '通过智慧算法生成',
  当前暂无策略: '当前暂无策略',
  请确认是否启用智慧控制启用后将会停止人工控制策略进入待机状态直到新的智慧控制策略下发: '请确认是否启用智慧控制，启用后将会停止人工控制策略，进入待机状态，直到新的智慧控制策略下发！',
  请确认是否启用人工控制启用后智慧控制策略将会被停用: '请确认是否启用人工控制，启用后智慧控制策略将会被停用！',
  动态电价: '动态电价',
  数据来源: '数据来源',
  请确认是否解除同步解除同步后将停止获取新的电价信息: '请确认是否解除同步，解除同步后将停止获取新的电价信息！',
  计划SOC: '计划SOC',
  请输入计划SOC: '请输入计划SOC',
  已同步至: '已同步至',
  '请确认是否修改当前电价，修改后仅保留上传修改数据！': '请确认是否修改当前电价，修改后仅保留上传修改数据！',
  '电价数值范围 1-9999 整数': '电价数值范围 1-9999 整数',
  暂未配置电价请点击同步电价: '暂未配置电价，请点击同步电价',
  当前同步电价未绑定到达同步日期后将停止更新电价信息请及时配置电价以免影响电站收益统计: '当前同步电价未绑定，到达同步日期后将停止更新电价信息，请及时配置电价，以免影响电站收益统计！',
  暂未获取到当日电价: '暂未获取到当日电价',
  组: '组',
  单体: '单体',
  单体电池: '单体电池',
  DCDC设备故障字: 'DCDC设备故障字',
  DCDC故障状态字: 'DCDC故障状态字',
  重置统计: '重置统计',
  此操作将清除当前站点下全部系统的告警历史及统计数据是否确认清除: '此操作将清除当前站点下全部系统的告警历史及统计数据，是否确认清除？',
  此操作将清除当前系统下全部系统的告警历史及统计数据是否确认清除: '此操作将清除当前系统下全部系统的告警历史及统计数据，是否确认清除？',
  重置站点告警: '重置站点告警',
  重置系统告警: '重置系统告警',
  重置成功: '重置成功',
  是否删除此告警: '是否删除此告警？',
  结束: '结束',
  结束告警: '结束告警',
  时区: '时区',
  结束时间不能小于开始时间: '结束时间不能小于开始时间',
  运维处理今日: '运维处理（今日）',
  表示当前站点系统的设备告警状态告警内容为运维处理内容: '表示当前站点系统的设备告警状态，告警内容为运维处理内容。',
  当前的告警内容为运维处理内容: '当前的告警内容为运维处理内容。',
  光伏开关控制: '光伏开关控制',
  是否确认开启光伏逆变器: '是否确认开启光伏逆变器？',
  是否确认关闭光伏逆变器: '是否确认关闭光伏逆变器？',
  设备复位: '设备复位',
  光伏强控: '光伏强控',
  电流互感器变比: '电流互感器变比',
  电压互感器变比: '电压互感器变比',
  累计正向总电能原始值: '累计正向总电能（原始值）',
  累计反向总电能原始值: '累计反向总电能（原始值）',
  请输入系统名称搜索: '请输入系统名称搜索',

  控制配置: '控制配置',
  引用配置: '引用配置',
  SOC参数设置: 'SOC参数设置',
  PCS启停: 'PCS启停',
  PCS模式控制: 'PCS模式控制',
  PCS并离网控制: 'PCS并离网控制',
  BMS二级保护: 'BMS二级保护',
  空调启停: '空调启停',
  空调工作模式设置: '空调工作模式设置',
  空调参数设置: '空调参数设置',
  TMS工作模式设置: 'TMS工作模式设置',
  消防启停: '消防启停',
  UPS启停: 'UPS启停',
  充电桩启停: '充电桩启停',
  柴发启停: '柴发启停',
  BMS并离网: 'BMS并离网',
  光伏启停: '光伏启停',
  光伏复位: '光伏复位',
  DCDC启停控制: 'DCDC启停控制',
  DCDC故障复位控制: 'DCDC故障复位控制',
  确认: '确认',
  默认开启能量管理下的手动能量控制防过载防逆流功能可选中或取消控制配置点击确认以下发: '默认开启能量管理下的手动能量控制、防过载、防逆流功能，可选中或取消控制配置，点击确认以下发！',
  请选择要引用配置的系统引用后将会覆盖当前内容: '请选择要引用配置的系统，引用后将会覆盖当前内容！',
  系统绑定: '系统绑定',
  主从配置: '主从配置',
  请确认是否绑定该系统到当前站点: '请确认是否绑定该系统到当前站点！',
  主从模式: '主从模式',
  输入编号: '输入编号',
  主机: '主机',
  从机: '从机',
  未知: '未知',
  部分编号未添加: '部分编号未添加',
  主机数量必须为1: '主机数量必须为1',
  禁止输入重复编号: '禁止输入重复编号！',
  系统控制: '系统控制',
  设备控制: '设备控制',
  关联设备: '关联设备',
  已选系统: '已选系统',
  当前主从配置只针对平台展示并不会更改实际主从模式配置: '当前主从配置只针对平台展示，并不会更改实际主从模式配置。',
  是否确认解绑: '是否确认解绑？',
  暂无系统可点击系统绑定进行添加: '暂无系统，可点击系统绑定进行添加',
  请输入系统编号系统名称ems编号: '请输入系统编号/系统名称/ems编号',
  过载保护: '过载保护',
  主从编号: '主从编号',
  暂未选择系统: '暂未选择系统',
  暂不支持输入0: '暂不支持输入0！',
  共: '共',
  项数据: '项数据',

  DCDC强控: 'DCDC强控',
  输入端电压: '输入端电压',
  恒流充放电: '恒流充放电',
  恒压充放电: '恒压充放电',
  恒功率充放电: '恒功率充放电',
  高压侧恒压: '高压侧恒压',
  输入端电流: '输入端电流',
  输出端电压: '输出端电压',
  输出端电流: '输出端电流',
  输入端功率: '输入端功率',
  输出端功率: '输出端功率',
  机内温度: '机内温度',
  视在功率: '视在功率',
  触发: '触发',
  声光报警器: '声光报警器',
  PCS触发信号: 'PCS触发信号',
  门禁灯: '门禁灯',
  断路器驱动: '断路器驱动',
  空调干节点: '空调干节点',
  消防干节点: '消防干节点',
  风扇继电器: '风扇继电器',
  显示屏控制: '显示屏控制',
  充电桩控制: '充电桩控制',
  设备录入: '设备录入',
  引用配置: '引用配置',
  请选择要引用配置的系统引用后将会覆盖当前配置内容: '请选择要引用配置的系统,引用后将会覆盖当前配置内容!',
  可选中设备后输入设备数量点击确认新增设备: '可选中设备后输入设备数量,点击确认新增设备。',
  选择系统: '选择系统',
  新增设备: '新增设备',
  储能电表: '储能电表',
  电网连接点电表_低压侧: '电网连接点电表_低压侧',
  电网连接点电表_高压侧: '电网连接点电表_高压侧',
  负载电表: '负载电表',
  储能监测电表: '储能监测电表',
  光伏电表: '光伏电表',
  设备序号或者型号不能重复: '设备序号或者型号不能重复!',
  厂家: '厂家',
  型号: '型号',
  设备id: '设备id',
  数量: '数量',
  请确认是否取消当前设备录入配置退出页面后录入信息不会保存需重新录入: '请确认是否取消当前设备录入配置，退出页面后录入信息不会保存，需重新录入！',
  请确认是否保存当前设备录入信息: '请确认是否保存当前设备录入信息!',
  选择系统: '选择系统',
  若填写电池堆数量电池堆下至少电池簇数量填1不能为空: '若填写电池堆数量，电池堆下至少电池簇数量填1，不能为空！',
  字母数字下划线组成: '字母数字下划线组成',
  设备ID长度为150: '设备ID长度为1-50',
  输入的数量必须是整型数值: '输入的数量必须是整型数值',
  只能输入数值: '只能输入数值',
  设备序号或者设备Id不能重复: '设备序号或者设备Id不能重复',
  信息不能为空: '信息不能为空',
  设备录入成功: '设备录入成功!',
  设备ID: '设备ID',
  型号: '型号',
  断路器: '断路器',
  pcs状态信号: 'pcs状态信号',
  柜体风机反馈: '柜体风机反馈',
  添加设备后请填写设备信息其中序号和设备ID为必填项厂家和型号为非必填项: '添加设备后请填写设备信息，其中序号和设备ID为必填项，厂家和型号为非必填项。',
  是否确认删除当前设备: '是否确认删除当前设备？',
  是否要删除当前选择的设备: '是否要删除当前选择的设备？',
  调速器: '调速器',
  待运维处理: '待运维处理',
  待运维: '待运维',
  发生中告警: '发生中告警',
  无需关注: '无需关注',
  初始化: '初始化',
  等待: '等待',
  烧录: '烧录',
  机组断路器状态: '机组断路器状态',
  市电断路器状态: '市电断路器状态',
  发动机油压: '发动机油压',
  发动机水温: '发动机水温',
  发动机燃油油位: '发动机燃油油位',
  充电发电机电压: '充电发电机电压',
  蓄电池电压: '蓄电池电压',
  发动机转速: '发动机转速',
  发动机运行时间: '发动机运行时间',
  启动次数: '启动次数',
  柴发控制: '柴发控制',
  柴发: '柴发',
  机组状态: '机组状态',
  秒: '秒',
  报警: '报警',
  有效: '有效',
  无效: '无效',
  测试: '测试',
  engine工作状态: 'engine工作状态',
  发电机总有功功率: '发电机总有功功率',
  发电机总无功功率: '发电机总无功功率',
  发电机总视在功率: '发电机总视在功率',
  合闸: '合闸',
  分闸: '分闸',
  辅电信号: '辅电信号',
  软件复位: '软件复位',
  请确认是否下发软件复位指令: '请确认是否下发软件复位指令',

  待运维处理: '待运维处理',
  待运维: '待运维',
  一般: '一般',
  重要: '重要',
  严重: '严重',
  未分级: '未分级',
  告警中心: '告警中心',
  告警监控: '告警监控',
  告警电站: '告警电站',
  告警总览: '告警总览',
  待运维处理电站: '待运维处理电站',
  告警中电站: '告警中电站',
  待运维处理告警: '待运维处理告警',
  发生中告警: '发生中告警',
  电站筛选: '电站筛选',
  全部电站: '全部电站',
  无需关注电站: '无需关注电站',
  待运维电站: '待运维电站',
  告警详情: '告警详情',
  告警总数: '告警总数',
  待运维告警: '待运维告警',
  无需关注告警: '无需关注告警',
  告警类型: '告警类型',
  等级: '等级',
  类型: '类型',
  详情: '详情',
  电站系统: '电站系统',
  运维告警详情: '运维告警详情',
  已结束告警记录只保留近7日更多告警信息请前往右上角告警历史查看: '已结束告警记录只保留近7日，更多告警信息请前往右上角“告警历史”查看',
  '此操作前提是必须先选择指定站点系统！': '此操作前提是必须先选择指定站点系统！',
  站点告警: '站点告警',
  电站告警详情: '电站告警详情',
  历史告警: '历史告警',
  历史告警: '历史告警',
  告警筛选: '告警筛选',
  通讯: '通讯',
  复制成功: '复制成功',
  事故总信号: '事故总信号',
  过流I段跳闸: '过流I段跳闸',
  过流II段跳闸: '过流II段跳闸',
  过流III段跳闸: '过流III段跳闸',
  过流I段压板: '过流I段压板',
  过流II段压板: '过流II段压板',
  过流III段压板: '过流III段压板',
  请确认是否下发设备复位指令: '请确认是否下发设备复位指令？',
  出水温度: '出水温度',
  进水温度: '进水温度',
  水泵状态: '水泵状态',
  补水泵运行状态: '补水泵运行状态',
  外风机状态: '外风机状态',
  吸气温度: '吸气温度',
  板换温度: '板换温度',
  冷凝盘管温度: '冷凝盘管温度',
  进出水压差值: '进出水压差值',
  高压侧压力值: '高压侧压力值',
  低压侧压力值: '低压侧压力值',
  电子膨胀阀开度: '电子膨胀阀开度',
  交流供电电压: '交流供电电压',
  压缩机转速: '压缩机转速',
  累计充电电量: '累计充电电量',
  充电电压: '充电电压',
  充电电流: '充电电流',
  充电功率: '充电功率',
  充电请求功率: '充电请求功率',
  最大允许充电功率: '最大允许充电功率',
  充电枪已连接: '充电枪已连接',
  充电结束: '充电结束',
  防逆流功能禁能中如需操作请使能: '防逆流功能禁能中，如需操作请使能！',
  防过载功能禁能中如需操作请使能: '防过载功能禁能中，如需操作请使能！',
  禁用时段设置: '禁用时段设置',
  用于设置防逆流功能禁能时段通过开关控制功能是否启用每次调整后需点击应用按钮方可生效: '用于设置防逆流功能禁能时段，通过开关控制功能是否启用，每次调整后需点击“应用”按钮方可生效',
  控制开关: '控制开关',
  禁能时段: '禁能时段',
  重新启用: '重新启用',
  是否确定重新启用: '是否确定重新启用？',
  系统2: '系统',
  统计配置: '统计配置',
  重新选择: '重新选择',
  时区偏移量: '时区偏移量',
  基本信息: '基本信息',
  统计状态: '统计状态',
  已开启: '已开启',
  统计开始时间: '统计开始时间',
  最多支持查看7日范围的数据: '最多支持查看7日范围的数据',
  '请重新选择统计开始时间（建议选择充放电量都为0的时间点）': '请重新选择统计开始时间（建议选择充放电量都为0的时间点）',
  '开启统计配置时，建议选择充放电量都为0的时间点，请先确认EMS本地能耗计已清零！': '开启统计配置时，建议选择充放电量都为0的时间点，请先确认EMS本地能耗计已清零！',
  '开启统计配置时，请先确认EMS本地能耗计已清零！': '开启统计配置时，请先确认EMS本地能耗计已清零！',
  '当前统计未开启，请先选择统计开始时间（建议选择充放电量都为0的时间点）': '当前统计未开启，请先选择统计开始时间（建议选择充放电量都为0的时间点）',
  '请确认是否开启统计？': '请确认是否开启统计？',
  '开启统计后，平台将按照设置的“统计开始时间”进行统计！': '开启统计后，平台将按照设置的“统计开始时间”进行统计！',
  '请确认是否变更统计开始时间？': '请确认是否变更统计开始时间？',
  '变更后，平台将按照新设置的时间进行重新统计！': '变更后，平台将按照新设置的时间进行重新统计！',
  上次选择时间: '上次选择时间',
  '开启统计时间失败!': '开启统计时间失败!',
  选择日期时间: '选择日期时间',
  请选择统计开始时间: '请选择统计开始时间',
  统计开始时间未变更: '统计开始时间未变更',
  '能量控制-导入表格.xlsx': '能量控制-导入表格.xlsx',
  '请确认是否导入Excel,导入后将覆盖当前内容！': '请确认是否导入Excel,导入后将覆盖当前内容！',
  '设置参数后，需点击“应用”按钮方可执行。无充电或放电操作的时间段，将执行待机操作!（支持': '设置参数后，需点击“应用”按钮方可执行。无充电或放电操作的时间段，将执行待机操作!（支持',
  下载Excel模板: '下载Excel模板',
  ',填写完成后再进行Excel导入，导入成功后需点击应用以执行）': ',填写完成后再进行Excel导入，导入成功后需点击应用以执行）',
  Excel导入: 'Excel导入',
  '导入成功！': '导入成功',
  '导入失败!': '导入失败!',
  '请确认后点击应用执行！': '请确认后点击应用执行！',
  EMS通讯: 'EMS通讯',
  常用电源状态: '常用电源状态',
  备用电源状态: '备用电源状态',
  '常用电源 A 相电压': '常用电源 A 相电压',
  '常用电源 B 相电压': '常用电源 B 相电压',
  '常用电源 C 相电压 V': '常用电源 C 相电压 V',
  常用电源频率: '常用电源频率',
  '备用电源 A 相电压': '备用电源 A 相电压',
  '备用电源 B 相电压': '备用电源 B 相电压',
  '备用电源 C 相电压': '备用电源 C 相电压',
  备用电源频率: '备用电源频率',

  制冷目标温度: '制冷目标温度',
  制热目标温度: '制热目标温度',
  自循环温度: '自循环温度',
  请输入制冷开启温度: '请输入制冷开启温度',
  '制冷开启温度数值范围 -100 - 100整数': '制冷开启温度数值范围 -100 - 100整数',
  '制冷关闭温度数值范围 -100 - 100整数': '制冷关闭温度数值范围 -100 - 100整数',
  请输入制热开启温度: '请输入制热开启温度！',
  '制热开启温度数值范围 -100 - 100整数': '制热开启温度数值范围 -100 - 100整数',
  '制热关闭温度数值范围 -100 - 100整数': '制热关闭温度数值范围 -100 - 100整数',
  请输入制冷目标温度: '请输入制冷目标温度！',
  '制冷目标温度数值范围 -100 - 100整数': '制冷目标温度数值范围 -100 - 100整数',
  请输入制热目标温度: '请输入制热目标温度！',
  '制热目标温度数值范围 -100 - 100整数': '制热目标温度数值范围 -100 - 100整数',
  请输入自循环温度: '请输入自循环温度！',
  '自循环温度数值范围 -100 - 100整数': '自循环温度数值范围 -100 - 100整数',
  请确认是否应用TMS温度参数: '请确认是否应用TMS温度参数？',
  '制冷开启温度 - 制冷关闭温度 ≥ 1': '制冷开启温度 - 制冷关闭温度 ≥ 1',
  '制热关闭温度- 制热开启温度 ≥ 1': '制热关闭温度- 制热开启温度 ≥ 1',
  TMS参数设置: 'TMS参数设置',
  制冷温度需要均大于制热温度: '制冷温度需要均大于制热温度！',
  '请填写制冷开启温度 > 制冷关闭温度': '请填写制冷开启温度 > 制冷关闭温度！',
  '请填写制热关闭温度 > 制热开启温度': '请填写制热关闭温度 > 制热开启温度！',
  直流脱扣: '直流脱扣',
  交流脱扣: '交流脱扣',
  BMS控制: 'BMS控制',
  'BMS 控制': 'BMS 控制',
  BMS脱扣控制: 'BMS脱扣控制',
  BMS软件复位: 'BMS软件复位',
  '请确认是否下发该指令，指令每30秒内可下发一次！': '请确认是否下发该指令，指令每30秒内可下发一次！',
  用户类型: '用户类型',
  管理员: '管理员',
  普通用户: '普通用户',
  到期类型: '到期类型',
  永久: '永久',
  自定义时间: '自定义时间',
  到期时间: '到期时间',
  '7天': '7天',
  '15天': '15天',
  '30天': '30天',
  '6个月': '6个月',
  '1年': '1年',
  请选择到期时间: '请选择到期时间！',
  个人信息: '个人信息',
  账号名称: '账号名称',
  账号邮箱: '账号邮箱',
  账号手机: '账号手机',
  账号角色: '账号角色'
}
